import styles from "src/components/molecules/FavoriteItem/styles.module.css";
import FavoriteIcon from "src/assets/icons/star.svg";
import { Msg } from "src/i18n/Msg";

type Props = {
  onClick: () => void;
};

export const FavoriteItem: React.FC<Props> = ({ onClick }) => (
  <div className={styles.favorite} onClick={onClick} role="button">
    <img src={FavoriteIcon} alt="star" />
    <p>
      <Msg id="components.molecules.FavoriteItem.text" />
    </p>
  </div>
);
